
export const generateReferenceNumber = (invoiceNumber: string): string => {
  invoiceNumber = String(invoiceNumber).replace(/\D/g, '').padStart(3, '0');
  const weights = [7, 3, 1];
  const weightedSum = invoiceNumber.split('').reduceRight((acc, cv, ci, src) => {
    return acc + (Number(cv) * weights[(src.length - 1 - (ci)) % 3])
  }, 0);
  return `${invoiceNumber}${(Math.ceil(weightedSum / 10) * 10) - weightedSum}`;
};

// If the last digit is not a checksum, add checksum at the end. Else, leave as it is
export const correctReferenceNumber = (testRef: string): string => {
  if (!testRef) return '';
  const validRef = generateReferenceNumber(testRef.substring(0, testRef.length - 1));
  return validRef === testRef ? testRef : generateReferenceNumber(testRef);
};
